import React from "react";
import content from "../utils/content.json";
function Resume() {
  return (
    <section id="resume" className="container section">
      <div className="row">
        <div className="col-md-10">
          <h2 id="resume_header" className="section__title">
            {content.content.resume.title}
          </h2>
        </div>
      </div>
      <div className="row" id="professional-experience">
        <div className="col-md-8 section__resume resume-list">
          <h3 className="resume-list_title">
            {content.content.resume.professionalExperience.title}
          </h3>
          {content.content.resume.professionalExperience.experience.map(
            (experience, index) => (
              <div className="resume-list__block" key={index}>
                <p className="resume-list__block-title">{experience.company}</p>
                <p className="resume-list__block-date">
                  {experience.date} | {experience.location}
                </p>
                <p>{experience.position}</p>
                {experience.description.map((item, index) => (
                  <p key={index}>{item}</p>
                ))}
                {experience.awards?.map((award, index) => (
                  <p key={index} className="resume-list__block-award">
                    {award}
                  </p>
                ))}
              </div>
            )
          )}
        </div>
      </div>
      <div className="row" id="education">
        <div className="col-md-8 section__resume resume-list">
          <h3 className="resume-list_title">
            {content.content.resume.education.title}
          </h3>
          {content.content.resume.education.education.map((education, index) => (
            <div className="resume-list__block" key={index}>
              <p className="resume-list__block-title">{education.school}</p>
              <p className="resume-list__block-date">
                {education.date} | {education.degree}
              </p>
              {education.description.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Resume;
